export default {
  notifications: [],
  clickEvent: false
}
